import React from 'react';
import { FiTrash2 } from "react-icons/fi";

export const Preview = ({image, sources, setSources, images, setImages}) => {
    const [percent] = React.useState(0);
    const [err] = React.useState(false);

   // React.useEffect(()=>{
   //    console.log(`%${percent}`)
   //     up()
   // },[])
/*
    const up  =  async () => {
        if(image.file){
            const formData = new FormData();
            formData.append("image", image.file);
            try{

                // const res = await api.post('/posts/single',formData,{
                //     onUploadProgress: event => {
                //         let progress = (event.loaded / event.total) * 100;
                //         setPercent(progress)
                //     }
                // });

                let name = image.file?.name; 
                // setImages((prev)=>[{ name, path:res.data.path}, ...prev]);
                setDone(true);

                setPercent(0)
            }catch(err){
                console.log((err).message)
                setErr(true)
                setDone(false)
            }
        }
    }

    **/
 
    return (
        <li >
            <div>
                <div 
                onClick={()=>{
                    console.log(image)
                    setSources(sources.filter((i)=>i.path!==image.path))
                    setImages(images.filter((i)=>i.name!==image.file?.name))

                }}>
                <FiTrash2 
                    className="trash"
                />
              {/**   {percent>0 || err && <CircularProgress strokeWidth="5"  sqSize="50" percentage={percent} />} */}
                </div>
            
                <div className={`image ${err ? 'error': ''} ${ ( (percent===100 || percent===0) && !err) ? 'uploaded': ''} ${percent!==100 && percent > 0 ? 'uploading' :''} `}>
                    <img src={image.path} draggable={false} className={`${percent!==100 && percent>0 && 'blur'}`}  alt="" />
                </div>
            </div>
        </li>
    )
}
